import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class PushAttribute extends AbstractBlock {
  constructor() {
    super('push_v2', '');
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);
    // ShapeSettings.setTitleField(block,this.title);

    const power = new Blockly.FieldTextInput('10');
    block
      .appendDummyInput()
      .appendField(t.to('クリックした時', 'on_click'))
      .appendField(power, 'power')
      .appendField(t.to('のチカラでなぐる', 'push'));

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const power = CodeSetting.getFieldValue(block, 'power');
    // let str =  this.name_for_code + " = 'power:"  + power + "' " + attribute ;
    const str = CodeSetting.buildAttribute([[this.name_for_code, `power:${power}`]], attribute);
    return [str];
  }
}
